// useRecentList — the host side of one recent list's view (pins, removed
// from Recent, open order, sort, density): the device store for that list
// (recentListPreference.ts), shared by every surface that shows it. Opens
// are reported as they happen (an "opened" command), for "Last opened".

export { useRecentList };

import { useSyncExternalStore } from "react";
import type {
    RecentListCommand,
    RecentListView,
} from "../../../components/Sidebar/recentList.js";
import { recentListStore } from "../../recentListPreference.js";

// `defaults`: what the list starts as on a device that stored nothing.
const useRecentList = (
    list: string,
    defaults?: RecentListView,
): readonly [RecentListView, (cmd: RecentListCommand) => void] => {
    const store = recentListStore(list, defaults);
    const view = useSyncExternalStore(store.subscribe, store.get);

    return [view, store.dispatch];
};
